import { getHtml as _getHtml } from "util/tiptap"
import { extensions } from "@/app/components/Editor/extensions"

export const getHtml = (content: string): string | undefined => {
  return _getHtml(content, extensions)
}
